import { mapState } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      // 其他
      isLoading: false,
      // 接口列表
      reqFnList: {
        getHistoryMessage: {
          url: "cs/player-history-messages",
          method: "get",
        },
        csmessageMessage: {
          url: "cs-message",
          method: "post",
        },
        csDisconnect: {
          url: "cs-disconnect",
          method: "post",
        },
        customConfig: {
          url: "custom-config",
          method: "get",
        },
        csSaveSystemMsg: {
          url: "cs-save-system-msg",
          method: "post",
        },
        csSetOriginal: {
          url: "cs-set-original",
          method: "post",
        },
      },
      // 登录相关
      CHATURL: process.env.VUE_APP_CHATAPI,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  async created() {},
  watch: {},
  mounted() {},
  methods: {
    /**
     * 通用聊天接口请求方法
     * @param {string} apiKey - reqFnList 中的 key，如 'getHistoryMessage'
     * @param {object} queryData - 请求参数
     * @returns {Promise}
     */
    getChatFn(apiKey, queryData = {}) {
      let that = this;
      return new Promise((resolve, reject) => {
        that.reqLoading = true;
        
        // 获取接口配置
        const apiConfig = that.reqFnList[apiKey];
        if (!apiConfig) {
          reject(new Error(`未找到接口配置: ${apiKey}`));
          that.reqLoading = false;
          return;
        }
        
        let method = apiConfig.method;
        
        // 构建请求头
        const headers = {
          'Content-Type': 'application/json',
        };
        
        // 如果有登录 token，添加到请求头
        // if (that.userInfo && that.userInfo.loginToken) {
        //   headers['AuthorizationToken'] = `Bearer ${that.userInfo.loginToken}`;
        // }
        
        // 构建请求配置
        const axiosConfig = {
          method: method,
          url: that.CHATURL + apiConfig.url,
          timeout: 10000,
          headers: headers,
        };
        
        // 根据请求方法设置 data 或 params
        if (method === 'post' || method === 'POST') {
          axiosConfig.data = { ...queryData };
        } else {
          axiosConfig.params = { ...queryData };
        }
        
        axios(axiosConfig)
          .then((res) => {
            if (res.status === 200) {
              resolve(res.data);
            } else {
              reject(res);
            }
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            that.reqLoading = false;
          });
      });
    },
    
    async getHistoryMessage(params) {
      return this.getChatFn('getHistoryMessage', params);
    },
    async csmessageMessage(params) {
      return this.getChatFn('csmessageMessage', params);
    },
    async csDisconnect(params) {
      return this.getChatFn('csDisconnect', params);
    },
    async customConfig(params) {
      return this.getChatFn('customConfig', params);
    },
    async csSaveSystemMsg(params) {
      return this.getChatFn('csSaveSystemMsg', params);
    },
    async csSetOriginal(params) {
      return this.getChatFn('csSetOriginal', params);
    },
    
  },
};